import { z } from "zod";
export const UserRoleSchema = z.enum(["organizer", "admin"]);
export const UserSchema = z.object({
    id: z.string().uuid(),
    name: z.string().min(1),
    email: z.string().email(),
    role: UserRoleSchema.default("organizer"),
    created_at: z.string(),
    updated_at: z.string(),
});
// Omit pattern kept for future-proofing
export const PublicUserSchema = UserSchema;
